import React, { useCallback } from 'react';
import { Orchard } from '../../services/sprayService';
import OrchardSelector from './OrchardSelector';
import OrchardSelectionSummary from './OrchardSelectionSummary';

interface Props {
  orchards: Orchard[];
  selected: string[];
  onChange: (ids: string[]) => void;
  singleSelect?: boolean;
}

const OrchardPicker: React.FC<Props> = ({ orchards, selected, onChange, singleSelect = false }) => {
  const handleRemove = useCallback((id: string) => {
    onChange(selected.filter(s => s !== id));
  }, [selected, onChange]);

  return (
    <div>
      <OrchardSelector orchards={orchards} selected={selected} onChange={onChange} singleSelect={singleSelect} />
      <div className="mt-2">
        <OrchardSelectionSummary
          orchards={orchards}
          selectedIds={selected}
          onRemove={handleRemove}
        />
      </div>
    </div>
  );
};

export default OrchardPicker;
